import React, { useEffect, useState, useMemo, useRef } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
  Chip,
  Box,
  IconButton,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  CircularProgress,
} from "@mui/material";
import StoreSearch from "../../../Campaign/StoreSearch";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import styles from "../../JobBatch.module.css";
import axios from "axios";
import Decrypt from "../../../../../shared/utils/Decrypt";

import moment from "moment";
const AcceptedCluster = ({ onClusterChange, id, isPaintingService }) => {
  const [expandedCluster, setExpandedCluster] = React.useState(null);
  const [expandedBatch, setExpandedBatch] = React.useState(null);
  const batchRefs = useRef({});
  const containerRef = useRef(null);

  const handleAccordionToggle = (clusterTitle, batchTitle) => (event) => {
    event.stopPropagation();
    if (clusterTitle) {
      setExpandedCluster((prev) =>
        prev === clusterTitle ? null : clusterTitle,
      );
    }
    if (batchTitle) {
      setExpandedBatch((prev) => (prev === batchTitle ? null : batchTitle));
    }
  };

  // Helper function to calculate total jobs in a cluster
  const calculateTotalJobsInCluster = (cluster) => {
    return cluster?.batches.reduce(
      (total, batch) => total + (batch.jobs?.length || 0),
      0,
    );
  };

  const getStatusLabel = (status) => {
    switch (status) {
      case "Requested":
        return "PDI Status:Requested";
      case "Approved":
        return "PDI Status:Approved";
      case "Rejected":
        return "PDI Status:Rejected";
      case "Pending":
        return "PDI Status:Pending";
      default:
        return "Unknown Status";
    }
  };

  const [acceptedClusters, setAcceptedClusters] = useState([]);
  const [acceptedLoading, setAcceptedLoading] = useState(false);

  const fetchAllAcceptedCluster = async (id) => {
    setAcceptedLoading(true);
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_URL}/manufacturingJobs/acceptedVendorClusters?campaignId=${id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );
      if (data?.success && Array.isArray(data.data)) {
        setAcceptedClusters(data.data);
        onClusterChange(data.data.length);
      } else {
        setAcceptedClusters([]);
        onClusterChange(0);
      }
    } catch (error) {
      setAcceptedClusters([]);
      onClusterChange(0);
      console.error("Error while fetching accepted clusters", error);
    } finally {
      setAcceptedLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      fetchAllAcceptedCluster(id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const DataRow = ({ row }) => (
    <TableRow>
      <TableCell className={styles.tableCell}>
        <div className={styles.sharedTextStyle}>{row?.storeName}</div>
        <div
          className={styles.address2}
        >{`${row?.address},${row?.city},${row?.state}-${row?.zipCode}`}</div>
      </TableCell>
      <TableCell className={styles.tableCell}>
        <div className={styles.sharedTextStyle}>{row?.storeOwnerName}</div>
        <div className={styles.storeManagerContact}>
          {row?.storeOwnerPhoneNumber}
        </div>
      </TableCell>
      <TableCell className={styles.tableCell}>
        <div className={styles.sharedTextStyle}>
          {`${
            row?.product?.approvedWidth ?? row?.product?.productWidth ?? "N/A"
          } * 
         ${
           row?.product?.approvedHeight ?? row?.product?.productHeight ?? "N/A"
         } * 
         ${row?.product?.productThickness ?? "N/A"}`}
        </div>
      </TableCell>
      <TableCell className={styles.tableCell}>
        <div className={styles.sharedTextStyle}>
          {row?.product?.productType || "N/A"}
        </div>
      </TableCell>
      {/* <TableCell className={styles.tableCell}>
        <div className={styles.sharedTextStyle}>
          {row?.baseMaterial || "N/A"}
        </div>
      </TableCell> */}
      {/* <TableCell className={styles.tableCell}>
        <div className={styles.sharedTextStyle}>
          {row?.printDetails || "N/A"}
        </div>
      </TableCell> */}
      {/* <TableCell className={styles.tableCell}>
        {row?.product?.printImage ? (
          <div className={styles.iconLinkContainer}>
            <a
              href={row.product.printImage}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.iconLink}
            >
              <div className={styles.pdfIconWithText}>
                <img
                  src="/assests/AdminDashboard/pdfImage.png"
                  alt="Print File"
                  className={styles.pdfIcon}
                />
              </div>
            </a>
          </div>
        ) : (
          <div className={styles.sharedTextStyle}>No print file</div>
        )}
      </TableCell> */}
      {/* <TableCell className={styles.tableCell}>
        {row?.materialDetailsForFabrication?.cadFile ? (
          <div className={styles.iconLinkContainer}>
            <a
              href={row.materialDetailsForFabrication.cadFile}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.iconLink}
            >
              <div className={styles.pdfIconWithText}>
                <img
                  src="/assests/AdminDashboard/pdfImage.png"
                  alt="CAD File"
                  className={styles.pdfIcon}
                />
              </div>
            </a>
          </div>
        ) : (
          <div className={styles.sharedTextStyle}>No CAD file</div>
        )}
      </TableCell> */}
      {/* <TableCell className={styles.tableCell}>
        <div className={styles.sharedTextStyle}>
          {row.oemPreference || "N/A"}
        </div>
      </TableCell> */}
    </TableRow>
  );

  const searchData = useMemo(() => {
    const result = [];

    acceptedClusters.forEach((cluster) => {
      cluster.batches?.forEach((batch) => {
        batch.jobs?.forEach((job) => {
          result.push({
            id: job._id,
            storeName: job.storeName,

            clusterTitle: cluster.clusterTitle,

            batchTitle: batch.batchTitle,

            targetId: batch._id,

            subText: `${cluster.clusterTitle} → ${batch.batchTitle}`,
          });
        });
      });
    });

    return result;
  }, [acceptedClusters]);

  return (
    <Grid ref={containerRef} className={`${styles.scrollableContainer}`}>
      <div
        className="mx-3 py-2 sticky top-0 z-20 bg-white"
        
      >
        <StoreSearch
          data={searchData}
          searchKey="storeName"
          placeholder="Search Store"
          containerRef={containerRef}
          targetRefs={batchRefs}
          onSelect={(item) => {
            setExpandedCluster(item.clusterTitle);

            setExpandedBatch(item.batchTitle);
          }}
        />
      </div>
      {acceptedLoading ? (
        <div className={styles.noJobsStyle}>
          <CircularProgress />
        </div>
      ) : acceptedClusters.length === 0 ? (
        <div className={styles.noJobsStyle}>
          <Box className={styles.noJobsBox}>
            <p className={styles.noJobsText}>
              No clusters of batches available
            </p>
          </Box>
        </div>
      ) : (
        acceptedClusters.map((cluster, index) => (
          <Grid item xs={12} md={12} key={index} my={1} mx={2}>
            <Accordion expanded={expandedCluster === cluster?.clusterTitle}>
              <AccordionSummary
                expandIcon={
                  <IconButton
                    onClick={handleAccordionToggle(cluster?.clusterTitle)}
                  >
                    <ExpandMoreIcon />
                  </IconButton>
                }
                aria-controls={`panel-${index}-content`}
                id={`panel-${index}-header`}
                className={styles.accordionHeader}
              >
                <div className={styles.batchHeader}>
                  <div className={styles.clusterTitle}>
                    {cluster?.clusterTitle}
                  </div>
                  <div className={styles.chipContainer}>
                    <Chip
                      label={`Batches: ${cluster?.batches?.length || 0}`}
                      className={styles.chip}
                    />
                    <Chip
                      label={`Jobs: ${calculateTotalJobsInCluster(cluster)}`}
                      className={styles.chip}
                    />
                    <Chip
                      label={`Timeline: ${moment(
                        cluster?.jobStartingDate,
                      ).format("DD MMM YY")} - ${moment(
                        cluster?.jobCompletionDate,
                      ).format("DD MMM YY")}`}
                      className={styles.chip}
                    />
                    <Chip
                      label={
                        <div className={styles.linkWithImage}>
                          {cluster?.vendorId?.vendorBusinessName || "N/A"}
                        </div>
                      }
                      className={styles.chip}
                    />

                    <Chip
                      key={index}
                      label={
                        cluster?.vendorId
                          ? `${Decrypt(cluster?.vendorId?.ownerName)} - ${
                              Decrypt(
                                cluster?.vendorId?.ownerPrimaryContactNo,
                              ) || "N/A"
                            }`
                          : "No Contact Info"
                      }
                      className={styles.chip}
                    />

                    <Chip
                      label={`Advance Paid: ${cluster?.amountPaid || 0}`}
                      className={styles.approved}
                    />
                    <Chip
                      label={
                        cluster?.batches?.every((batch) => batch.status === 2)
                          ? "Complete"
                          : `Pending: ${
                              cluster?.batches?.filter(
                                (batch) => batch.status !== 2,
                              ).length || 0
                            }`
                      }
                      className={styles.pending}
                    />
                    {/* <button className={styles.ellipsisButton}>⋮</button> */}
                  </div>
                </div>
              </AccordionSummary>
              <AccordionDetails className={styles.accordionDetails}>
                <Box className={`${styles.scrollableBox}`}>
                  {cluster?.batches?.map((batch, batchIndex) => {
                    const isPainting = isPaintingService(batch);

                    return (
                      <div
                        ref={(el) => {
                          batchRefs.current[batch._id] = el;
                        }}
                      >
                        <Accordion
                          expanded={expandedBatch === batch.batchTitle}
                          key={batchIndex}
                          className={`${styles.accordionCustom}`}
                        >
                          <AccordionSummary
                            expandIcon={
                              <IconButton
                                onClick={handleAccordionToggle(
                                  null,
                                  batch.batchTitle,
                                )}
                              >
                                <ExpandMoreIcon />
                              </IconButton>
                            }
                            aria-controls={`panel-${batchIndex}-content`}
                            id={`panel-${batchIndex}-header`}
                          >
                            <div className={styles.batchHeader}>
                              <h1 className={styles.batchTitle}>
                                {batch.batchTitle}
                              </h1>
                              <div className={styles.chipContainer}>
                                <Chip
                                  label={`Jobs: ${batch.jobs?.length || 0}`}
                                  className={styles.chip}
                                />
                                {/* Only show PDI status chip if NOT painting service */}
                                {!isPainting && (
                                  <Chip
                                    label={getStatusLabel(batch.pdiStatus)}
                                    className={
                                      batch.pdiStatus === "Requested"
                                        ? styles.pdiRequested
                                        : batch.pdiStatus === "Approved"
                                          ? styles.pdiApproved
                                          : "" // Default case
                                    }
                                  />
                                )}
                              </div>
                            </div>
                          </AccordionSummary>
                          <AccordionDetails className={styles.accordionDetails}>
                            <Box className={`${styles.scrollableBox}`}>
                              <TableContainer
                                component={Paper}
                                className={styles.tableContainer}
                              >
                                <Table>
                                  <TableHead>
                                    <TableRow className={styles.tableHeader}>
                                      <TableCell className={styles.tableCell}>
                                        DELIVERY ADDRESS
                                      </TableCell>
                                      <TableCell className={styles.tableCell}>
                                        STORE MANAGER
                                      </TableCell>
                                      <TableCell className={styles.tableCell}>
                                        DIMENSIONS (W×H×T)
                                      </TableCell>
                                      <TableCell className={styles.tableCell}>
                                        PRODUCT TYPE
                                      </TableCell>
                                      {/* <TableCell className={styles.tableCell}>
                                      BASE MATERIAL
                                    </TableCell> */}
                                      {/* <TableCell className={styles.tableCell}>
                                      PRINT DETAILS
                                    </TableCell> */}
                                      {/* <TableCell className={styles.tableCell}>
                                      PRINT IMAGE
                                    </TableCell> */}
                                      {/* <TableCell className={styles.tableCell}>
                                      CAD FILE
                                    </TableCell> */}
                                      {/* <TableCell className={styles.tableCell}>
                                        OEM PREFERENCE
                                      </TableCell> */}
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {batch?.jobs?.map((row, rowIndex) => (
                                      <DataRow key={rowIndex} row={row} />
                                    ))}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </Box>
                          </AccordionDetails>
                        </Accordion>
                      </div>
                    );
                  })}
                </Box>
              </AccordionDetails>
            </Accordion>
          </Grid>
        ))
      )}
    </Grid>
  );
};

export default AcceptedCluster;
